var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticStyle:{"float":"left"}},[_vm._v(" Новости ")]),_c('publications',{attrs:{"type":"news","detail-route-name":"NewsDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }